import { useNavigate } from "react-router-dom";
import Logo from "../icon/Logo.svg";
import { useTranslation } from "react-i18next";
import ApplLogo from "../image/AppLogo.png";
import PlayStoreLogo from "../image/Playstore.png";
const Footer = () => {

    const { t } = useTranslation();
    const Navigate = useNavigate();

    const currentYear = new Date().getFullYear();

    const HandleOpenLink = (Link) => {
        window.open(Link, "blank");
    }


    return (
        <div className='footer_page'>
            <div className="footer_box">
                <div className="logo_box">
                    <button onClick={() => Navigate("/")} className="flex items-center justify-center gap-[10px]">
                        <img src={Logo} className='w-[40px]' alt="Logo" />
                        <h1 className="font-bold text-[25px]">{t("GoMechPro")}</h1>
                    </button>
                </div>

                <div className="details_box">
                    <h1>London</h1>
                    <p className="mt-[10px]">Germany 789 15h Street <br /> Offce 478 Berlin</p>
                </div>

                <div className="details_box">
                    <h1>Contact</h1>
                    <p className="mt-[10px]">+1 (234) 567 890 43</p>
                    <p>gomechpro@help.com</p>
                </div>

                <div className="details_box">
                    <h1>Social media</h1>
                    <div className="flex flex-wrap items-center max-_1145_:justify-center gap-[20px] mt-[10px]">
                        <button onClick={() => HandleOpenLink("https://apps.apple.com/")}>
                            <img src={ApplLogo} className="w-[150px] rounded-[10px] border-[1px] border-white " alt="ApplLogo" />
                        </button>
                        <button onClick={() => HandleOpenLink("https://play.google.com/")}>
                            <img src={PlayStoreLogo} className="w-[150px] rounded-[10px] border-[1px] border-white " alt="PlayStoreLogo" />
                        </button>
                    </div>
                </div>
            </div>

            <div className="border-t-[1px] border-white text-white text-center py-[20px]">
                <p>© {currentYear} GoMechPro. All Rights Reserved</p>
            </div>

        </div>
    )
}

export default Footer